import { Media, MediaBody, MediaLeft } from 'foundations-components/transitional/components/Media';
import AvatarLookup from './AvatarLookup';
import { View } from 'foundations-components/components/View';
import RecordLabel from './RecordLabel';
import PropertiesList from './PropertiesList';
import MultiAccountRecord from './MultiAccountRecord';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ContactCompanyDetails = ({
  isEditable = true
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Media, {
      spacing: "medium",
      align: "center",
      marginBlockEnd: "100",
      children: [/*#__PURE__*/_jsx(MediaLeft, {
        children: /*#__PURE__*/_jsx(AvatarLookup, {})
      }), /*#__PURE__*/_jsx(MediaBody, {
        children: /*#__PURE__*/_jsx(View, {
          marginBlockEnd: "100",
          children: /*#__PURE__*/_jsx(RecordLabel, {
            isEditable: isEditable
          })
        })
      })]
    }), /*#__PURE__*/_jsx(PropertiesList, {
      isEditable: isEditable
    }), /*#__PURE__*/_jsx(MultiAccountRecord, {})]
  });
};
export default ContactCompanyDetails;